var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerBackup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.304 13.2581L17.6248 24.6164C17.6135 24.6355 17.6079 24.6573 17.6084 24.6794C17.609 24.7016 17.6159 24.7231 17.6281 24.7415C17.6404 24.7599 17.6576 24.7745 17.6778 24.7835C17.698 24.7926 17.7204 24.7958 17.7423 24.7927H25.5756C25.595 24.7916 25.6143 24.7952 25.6319 24.8034C25.6495 24.8116 25.6648 24.824 25.6764 24.8395C25.6881 24.855 25.6957 24.8731 25.6986 24.8923C25.7015 24.9115 25.6996 24.9311 25.6931 24.9493L23.6565 33.9381C23.6435 33.9667 23.6424 33.9992 23.6534 34.0286C23.6644 34.058 23.6867 34.0818 23.7152 34.0948C23.7438 34.1077 23.7764 34.1088 23.8057 34.0978C23.8351 34.0868 23.8589 34.0646 23.8719 34.036L32.3123 21.4635C32.3225 21.4459 32.3279 21.426 32.3281 21.4057C32.3283 21.3854 32.3232 21.3654 32.3133 21.3476C32.3034 21.3299 32.2891 21.315 32.2718 21.3044C32.2545 21.2938 32.2347 21.2879 32.2144 21.2873H24.6552C24.6552 21.2873 24.479 21.1698 24.479 21.0914L28.6502 13.356C28.6604 13.3384 28.6658 13.3185 28.666 13.2982C28.6662 13.2779 28.6611 13.2579 28.6512 13.2401C28.6414 13.2224 28.6271 13.2075 28.6097 13.1969C28.5924 13.1863 28.5726 13.1804 28.5523 13.1798H23.4215C23.3961 13.1783 23.3708 13.1852 23.3497 13.1993C23.3285 13.2134 23.3124 13.2341 23.304 13.2581Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2041 23.3239C9.23888 20.2331 10.1872 17.2216 11.9297 14.6685C13.6721 12.1155 16.1309 10.1349 18.9965 8.97608C21.8621 7.81729 25.0065 7.53207 28.0338 8.15633C31.0611 8.78059 33.8361 10.2864 36.0096 12.4843C38.183 14.6822 39.6577 17.4739 40.2481 20.508C40.8384 23.5421 40.518 26.6831 39.3273 29.5355C38.1365 32.388 36.1285 34.8245 33.5561 36.5383C30.9837 38.2521 27.9618 39.1666 24.8708 39.1668",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.875 19.1329L9.30208 23.7742L13.4537 19.1329",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerBackup);
export default __webpack_public_path__ + "static/media/power_backup.a3bbdb845b501b39be4bed3470b55ca5.svg";
export { ForwardRef as ReactComponent };